export default {"src":"/_next/static/media/recaptcha_symbol.ab7be333.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};